// Distance-based sorting (client-side using Geolocation API)
function haversineDistance(lat1, lng1, lat2, lng2) {
  const R = 6371; // km
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng/2) * Math.sin(dLng/2);
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
}

function sortByDistance(lat, lng) {
  const container = document.getElementById('branch-list');
  if (!container) return;

  const allBoxes = Array.from(container.querySelectorAll('.store-box'));
  const withCoords = [];
  const withoutCoords = [];

  allBoxes.forEach(box => {
    const latVal = parseFloat(box.dataset.lat);
    const lngVal = parseFloat(box.dataset.lng);
    if (!isNaN(latVal) && !isNaN(lngVal) && latVal !== 0 && lngVal !== 0) {
      withCoords.push(box);
    } else {
      withoutCoords.push(box);
    }
  });

  withCoords.sort((a, b) => {
    const distA = haversineDistance(lat, lng, parseFloat(a.dataset.lat), parseFloat(a.dataset.lng));
    const distB = haversineDistance(lat, lng, parseFloat(b.dataset.lat), parseFloat(b.dataset.lng));
    return distA - distB;
  });

  withCoords.forEach(box => {
    const dist = haversineDistance(lat, lng, parseFloat(box.dataset.lat), parseFloat(box.dataset.lng));
    let label = box.querySelector('.distance-label');
    if (!label) {
      label = document.createElement('span');
      label.className = 'distance-label';
      const name = box.querySelector('.store-card-branch-name');
      if (name) name.after(label);
    }
    label.textContent = dist < 1 ? `${Math.round(dist * 1000)}m` : `${dist.toFixed(1)}km`;
    container.appendChild(box);
  });

  withoutCoords.forEach(box => container.appendChild(box));
}

function doDistanceSort() {
  if (!navigator.geolocation) {
    alert('お使いのブラウザは位置情報に対応していません');
    return;
  }
  navigator.geolocation.getCurrentPosition(
    pos => sortByDistance(pos.coords.latitude, pos.coords.longitude),
    err => {
      if (err.code === 1) {
        alert('位置情報が許可されていません。ブラウザの設定で許可してください。');
      } else if (err.code === 2) {
        alert('位置情報を取得できませんでした。');
      } else {
        alert('位置情報の取得がタイムアウトしました。再度お試しください。');
      }
    },
    { enableHighAccuracy: false, timeout: 30000, maximumAge: 300000 }
  );
}

function pushDataLayer(payload) {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  } catch (e) { /* no-op: 計測失敗で操作を止めない */ }
}

document.addEventListener('DOMContentLoaded', () => {
  // 「営業中のみ」フィルタ: GA4 計測（enabled 状態込み）→ 同一ハンドラ内で submit。
  // 旧 inline onchange="this.form.submit()" は push より先に走り計測が落ちるため JS に寄せた。
  const openOnly = document.getElementById('open-only-checkbox');
  if (openOnly) {
    openOnly.addEventListener('change', () => {
      pushDataLayer({ event: 'store_open_filter_change', enabled: openOnly.checked });
      const openForm = openOnly.closest('form');
      if (openForm) openForm.submit();
    });
  }

  const sortSelect = document.getElementById('sort-select');
  if (!sortSelect) return;

  const form = sortSelect.closest('form');
  const hasFlatList = !!document.getElementById('branch-list');

  // On page load: if distance is already selected and flat list exists, auto-sort
  if (sortSelect.value === 'distance' && hasFlatList) {
    doDistanceSort();
  }

  sortSelect.addEventListener('change', () => {
    // GA4 計測（GTM 経由）。選択値は動的なため dataLayer に直接 push。
    // 遷移を伴う場合の取りこぼしは GTM タグ側 transport_type:beacon で回避（OPERATIONS-gtm-ga4-events.md）。
    pushDataLayer({ event: 'store_sort_change', sort: sortSelect.value });

    if (sortSelect.value === 'distance') {
      if (hasFlatList) {
        // Already on flat list, sort in place
        doDistanceSort();
      } else {
        // Need flat list first, submit form to get it
        if (form) form.submit();
      }
    } else {
      // Server-side sort
      if (form) form.submit();
    }
  });
});
